import React, { useState } from 'react'
import img from "../../asstes/images/imoge.png"

const Prifel = () => {
    const [state,setState]= useState(1)
  return (
    <div>
        {state === 1 && (    <div>
        <h2 className='md:text-[64px] md:leading-[81px] text-[32px] mb-3 font-bold leading-[37px]'>Hola María! Bienvenid@ a tu portal de ciberconta</h2>
        <p className='md:text-[24px] md:leading-[81px] text-[14px] leading-[37px] '>Bienvenida a tu perfil de ciberconta, <span className=' text-red-500'>aún te falta llenar toda tu</span></p> 
        <p className='md:text-[24px] md:leading-[81px] text-[14px] leading-[37px] '><span className=' text-red-700 border-b border-red-700'>Información General</span>  puedes encontrar la sección en la parte derecha</p>
        <p className='md:text-[24px] md:leading-[81px] text-[14px] leading-[37px] '>del menú en tu portal, si tienes dudas sobre como llenar tu información</p>
        <p className='md:text-[24px] md:leading-[81px] text-[14px] leading-[37px] '>escríbenos al chat, un asesor te ayudará a llenar todos los campos.</p>
    </div>)}
    {state === 2 && (   <div>
        <h2 className='md:text-[64px] md:leading-[81px] text-[32px] mb-5 font-bold leading-[37px]'>Hola María! Bienvenid@ a tu portal de ciberconta</h2>
       
            <div className='flex items-center justify-center gap-2'>
                    <img src={img} alt="" />
                    <p>¡Tu plan ha expirado!</p>
                    <img src={img} alt="" />
            </div>
            <div className='flex items-center justify-center mt-8'>
            <button className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>Solucionar problema</button>
            </div>
      
    </div>)}

    {state === 3 && (    <div>
        <h2 className='md:text-[64px] md:leading-[81px] text-[32px] mb-3 font-bold leading-[37px]'>Hola María! Bienvenid@ a tu portal de ciberconta</h2>

    </div>)}
    </div>
  )
}

export default Prifel